module.exports = "<router-outlet></router-outlet>"


//////////////////
// WEBPACK FOOTER
// /home/jenkins-agent/workspaces/workspace/enmapa-gis-mob-frontend/src/app/app.component.html
// module id = ../../../../../src/app/app.component.html
// module chunks = main